@if (data.list && data.list.length > 0) {
  <ng-template [ngTemplateOutlet]="listTpl" />
} @else {
  <div class="notice-icon__notfound">
    @if (data.emptyImage) {
      <img class="notice-icon__notfound-img" [attr.src]="data.emptyImage" alt="not found" />
    }
    <p>
      <ng-container *nzStringTemplateOutlet="data.emptyText">
        {{ data.emptyText || locale['emptyText'] }}
      </ng-container>
    </p>
  </div>
}
<ng-template #listTpl>
  <nz-list [nzDataSource]="data.list" [nzRenderItem]="item">
    <ng-template #item let-item>
      <nz-list-item (click)="onClick(item)" [class.notice-icon__item-read]="item.read">
        <nz-list-item-meta [nzTitle]="nzTitle" [nzDescription]="nzDescription" [nzAvatar]="item.avatar">
          <ng-template #nzTitle>
            <ng-container *nzStringTemplateOutlet="item.title; context: { $implicit: item }">
              {{ item.title }}
            </ng-container>
            @if (item.extra) {
              <div class="notice-icon__item-extra">
                <nz-tag [nzColor]="item.color">{{ item.extra }}</nz-tag>
              </div>
            }
          </ng-template>
          <ng-template #nzDescription>
            @if (item.description) {
              <div class="notice-icon__item-desc">
                <ng-container *nzStringTemplateOutlet="item.description; context: { $implicit: item }">
                  {{ item.description }}
                </ng-container>
              </div>
            }
            @if (item.datetime) {
              <div class="notice-icon__item-time">{{ item.datetime }}</div>
            }
          </ng-template>
        </nz-list-item-meta>
      </nz-list-item>
    </ng-template>
  </nz-list>
  <div class="notice-icon__clear" (click)="onClear()">{{ data.clearText || locale['clearText'] }}</div>
</ng-template>
